import OutOfMeetingNavigation from "../components/Navigation/OutOfMeetingNavigation";
import FullScreenSpinner from "../components/FullScreenSpinner";
import {useAppSelector} from "../hooks";
import {useGetHostSettingsQuery} from "../app/appApiQueries";
import {selectShowFTE} from "../app/hostSettings";
import Onboarding from "./Onborading";

function OutOfMeetingHome() {
    const { isLoading: isHostSettingsLoading } =
        useGetHostSettingsQuery('hostSettings')

    // obtain the initial state of showFTE
    const showFTE = useAppSelector(selectShowFTE)
  return (
      <>
        {isHostSettingsLoading ? (
            <FullScreenSpinner />
        )  : showFTE ? (
            <Onboarding />
        ) : !showFTE && (
            <OutOfMeetingNavigation />
        )
        }
      </>
  )
}

export default OutOfMeetingHome
